import React from 'react';

const LocationsIcon = () => (
    
    <svg width="39" height="40" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640">
        <path d="M80 263.6L147.8 128L492.2 128L560 263.6L560 288L80 288L80 263.6zM80 320L96 320L96 544L384 544L384 320L512 320L512 544L544 544L544 320L592 320L592 256L512 96L128 96L48 256L48 320L80 320zM128 416L128 320L352 320L352 416L128 416zM128 448L352 448L352 512L128 512L128 448z"/>
    </svg>

);

export default LocationsIcon;
